// extracted by mini-css-extract-plugin
module.exports = {"title":"Loader_title__ZYKDE","img":"Loader_img__1a85_"};